import { Component, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { IntegrationStatus } from 'src/app/models/integration-status';
import { ActionService } from 'src/app/services/action.service';
import { BusinessLogicService } from 'src/app/services/business-logic.service';

@Component({
    selector: 'app-integration-history',
    templateUrl: './integration-history.component.html',
    styleUrls: ['./integration-history.component.css'],
    standalone: false
})
export class IntegrationHistoryComponent implements OnInit, OnDestroy {

  public $history: BehaviorSubject<IntegrationStatus[]> = new BehaviorSubject<IntegrationStatus[]>(null);
  public history: Observable<IntegrationStatus[]>;
  private subscriptions: Subscription = new Subscription();

  // watches history collection in durable function service. updates the rendered "state" of a previously
  // run or running instance when the values change. 
  constructor(
    private businessLogicService: BusinessLogicService, 
    private actionService:ActionService) {}

  ngOnInit(): void {
    this.subscriptions.add(this.actionService.$integrationNameSelected.subscribe(integrationName => {
      if(integrationName != null) {
        this.getIntegrationHistoryBehaviorSubject(integrationName);
      } 
    }));
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private getIntegrationHistoryBehaviorSubject(integrationName: string){
    this.$history = this.businessLogicService.getIntegrationHistoryBehaviorSubject(integrationName);
    this.history = this.$history.asObservable();
  }
}
